import { useDispatch } from '@witmetrics/data-store';
import { API } from '@/api';
import { showSuccessToaster } from '@/utils/toasters';
import { useAppState } from '@/providers/AppStateProvider';
import { useToggle } from '@/hooks/useToggle';
import { TrashIcon } from '@/icons';
import DefaultDialog from '@/components/Dialog/DefaultDialog';

export type DeleteKeypointDialogProps = {
  keypointId: number;
  onClose: () => void;
};

export default function DeleteKeypointDialog({
  keypointId,
  onClose,
}: DeleteKeypointDialogProps) {
  const dispatch = useDispatch();
  const { onApiError } = useAppState();
  const [isDeleting, toggleDeleting] = useToggle();

  const handleDelete = async () => {
    try {
      toggleDeleting(true);
      await API.Keypoints.removeKeypoint(keypointId);
      dispatch.deleteKeypoint({ keypointId });
      showSuccessToaster('Keypoint deleted');
      toggleDeleting(false);
      onClose();
    } catch (err) {
      toggleDeleting(false);
      onApiError(err, 'Error deleting keypoint');
    }
  };

  return (
    <DefaultDialog
      disabled={isDeleting}
      pending={isDeleting}
      variant="confirm"
      icon={<TrashIcon size="1.375rem" />}
      confirmLabel="Delete"
      pendingLabel="Deleting"
      title="Delete keypoint"
      message="Are you sure you want to delete this keypoint? This action cannot be undone."
      onCancel={onClose}
      onConfirm={handleDelete}
      onClose={onClose}
    />
  );
}
